
import {SourcesInline} from 'components/sources-v2'
import CollapsedMdTable from './collapsed-md-table.vue'
import ExternalLink from 'components/external-link'
import Widgets from 'components/widgets'

export default {
  components: {ExternalLink, CollapsedMdTable, SourcesInline, Widgets},
  props: {
    nodes: {
      type: NodeList, required: true
    },
    restricted: {
      type: Boolean, default: false
    }
  },
  computed: {
    processed_nodes(){
      let result = []
      this.nodes.forEach((n, i) => {
        const item = {node: n}
        if (n.nodeType === Node.ELEMENT_NODE) {

          if (n.tagName === 'BUTTON') {
            if (n.attributes) {
              const btn_type = n.attributes.getNamedItem('type')
              if (btn_type.value === 'inline') {
                const btn_click = n.attributes.getNamedItem('click')
                return result.push({
                  ...item,
                  type: 'button',
                  text: n.innerText,
                  click: +btn_click.value
                })
              }
            }
          }

          if (n.tagName === 'A') {
            if (n.href.startsWith('mailto:')) {
              return result.push({
                ...item,
                text: n.textContent,
                type: 'mailto-link',
                href: n.href
              })
            }
            else if (n.href.startsWith('sources://')) {
              return result.push({
                ...item,
                text: n.innerText,
                type: 'sources',
                href: n.href
              })
            }
            else if (n.href.startsWith('widgets://')) {
              return result.push({
                ...item,
                type: 'widgets',
                href: n.href
              })
            }
            else if (n.href.startsWith('entity://')) {
              return result.push({
                ...item,
                text: n.innerText,
                type: 'apollo-link',
                href: n.href
              })
            }
            else {
              return result.push({
                ...item,
                type: 'external-link',
                href: n.href
              })
            }
          } 


          if (n.tagName === 'TABLE') {
            let title = undefined
            const prev = result.findLast(n => n.type === 'parent' && ['H2', 'H3', 'P'].includes(n.name))
            if (prev) {
              title = prev
              result = result.filter(n => n !== title)
            }
            return result.push({
              ...item,
              type: 'table', content: n.childNodes, title
            })
          } 
        }


        const attributes = {}
        for (let attr of n.attributes || []) {
          if (attr.name === 'href') continue
          attributes[attr.name] = attr.value
        }

        const parent = n.childNodes?.length > 0
        return result.push({
          ...item,
          type: parent ? 'parent' : undefined,
          content: parent ? n.childNodes : (n.innerHtml || n.textContent),
          name: n.tagName,
          attributes
        })
      })
      return result
    }
  }
}
